// @flow
import React from 'react';

import { BadgeName } from '@app/components/badges/badge-name';
import { T } from '@app/components/translation';

import { RemoveConfirm } from '../remove-confirm';

type Props = {
  tag: Tag,
  removeState: RemoveState,
  resetRemoveState: Function,
  removeTag: Function,
  children: Function,
};

export const RemoveTagConfirmation = ({
  tag,
  removeState,
  resetRemoveState,
  removeTag,
  children,
}: Props) => (
  <RemoveConfirm
    onConfirm={removeTag}
    confirmState={removeState}
    resetConfirmState={resetRemoveState}
    confirmMessage={(
      <>
        <T
          _str="You are about to delete {name}. This action can't be undone."
          name={<BadgeName>{tag.name}</BadgeName>}
          _comment="Modal text when deleting a tag."
        />
        <T
          _str="This tag will be also removed from all contracts and templates where it is used."
          _comment="Modal text when deleting a tag."
        />
      </>
    )}
    modalKey="delete tag modal"
  >
    {children}
  </RemoveConfirm>
);
